import { DistictGridComponent } from './pages/master/district/distict-grid/distict-grid.component';


import { ArmDetailsComponent } from './pages/functions/arm-details/arm-details.component';
import { NotificationGridComponent } from './pages/functions/notification/notification-grid/notification-grid.component';
import { CriminalQueriesComponent } from './pages/functions/staff-criminal-proceedings/criminal-queries/criminal-queries.component';
import { ViewCriminalEmpComponent } from './pages/functions/staff-criminal-proceedings/view-criminal-emp/view-criminal-emp.component';
import { PsadetailsFormComponent } from './pages/functions/psadetails/psadetails-form/psadetails-form.component';
import { PsadetailsGridComponent } from './pages/functions/psadetails/psadetails-grid/psadetails-grid.component';
import { PsadetailsComponent } from './pages/functions/psadetails/psadetails.component';
import { HomeIsDepartmentComponent } from './pages/home/home-is-department/home-is-department.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
// import {RouterModule} from '@angular/router';

//Material Design Css import
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatButtonModule, MatCheckboxModule, MatTooltipModule} from '@angular/material';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule} from '@angular/material/radio';
import { MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
//Material Design Css import


import { AppComponent } from './khb.component';
import { HeaderComponent } from './common/header/header.component';
import { Level1menuComponent } from './common/level1menu/level1menu.component';
import { UltilitiesComponent } from './ultilities/ultilities.component';
import { UltilitiesMenuComponent } from './ultilities/ultilities-menu/ultilities-menu.component';
import { UserComponent } from './ultilities/user/user.component';
import { SettingComponent } from './ultilities/setting/setting.component';
import { SearchbarComponent } from './common/searchbar/searchbar.component';
import { RolesComponent } from './ultilities/roles/roles.component';
import { RolesGridComponent } from './ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './ultilities/roles/roles-form/roles-form.component';
import { UserService } from './shared/user.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginComponent } from './registration/login/login.component';
import { SignupComponent } from './registration/signup/signup.component';
import { UserGridComponent } from './ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './ultilities/user/user-form/user-form.component';
import { ClaimGridComponent } from './ultilities/claims/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './ultilities/claims/claims/claim-form/claim-form.component';
import { ClaimsComponent } from './ultilities/claims/claims/claims.component';
import { RegistrationComponent } from './registration/registration.component';
import { ErrorHandler } from './shared/ErrorHandler';
import {NgxPaginationModule} from 'ngx-pagination';
import { appRoutes } from '../route';
import { HomepageComponent } from './homepage/homepage.component';
import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { ChangePasswordComponent } from './ultilities/change-password/change-password.component';
import { ForgotPasswordComponent } from './registration/forgot-password/forgot-password.component';

import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { PetitionComponent } from './petition/petition.component';
import { PetitionMenuComponent } from './petition/petition-menu/petition-menu.component';
import { PetitionGridComponent } from './petition/petition-grid/petition-grid.component';
import { PetitionFormComponent } from './petition/petition-form/petition-form.component';
import { PetitionApprovalComponent } from './petition/petition-approval/petition-approval.component';

import { VehicleGridComponent } from './ultilities/vehicle/vehicle-grid/vehicle-grid.component';
import { VehicleFormComponent } from './ultilities/vehicle/vehicle-form/vehicle-form.component';


import { PetitionApprovalGridComponent } from './petition/petition-approval-grid/petition-approval-grid.component';
import { CorrespondanceTrackingComponent } from './correspondance-tracking/correspondance-tracking.component';
import { CtGridComponent } from './correspondance-tracking/ct-grid/ct-grid.component';
import { CtFormComponent } from './correspondance-tracking/ct-form/ct-form.component';
import { CtMenuComponent } from './correspondance-tracking/ct-menu/ct-menu.component';
import { FooterComponent } from './common/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { ViewComponent } from './pages/view/view.component';
import { MasterComponent } from './pages/master/master.component';
import { FunctionsComponent } from './pages/functions/functions.component';
import { RptFormComponent } from './pages/view/rpt-form/rpt-form.component';
import { LicenceRequestMenuComponent } from './pages/functions/lience-reuest/licence-request-menu/licence-request-menu.component';
import { ReportForm2Component } from './pages/functions/report-form2/report-form2.component';
import { EmpHistoryComponent } from './pages/functions/emp-history/emp-history.component';
import { NotificationFormComponent } from './pages/functions/notification/notification-form/notification-form.component';

import { DistictFormComponent } from './pages/master/district/distict-form/distict-form.component';
import { MasterDetailsComponent } from './pages/master/master-details/master-details.component';
import { ViewDetailsComponent } from './pages/view/view-details/view-details.component';
import { PsaCriminalProceedingsListComponent } from './pages/home/psa-criminal-proceedings-list/psa-criminal-proceedings-list.component';
import { BranchGridComponent } from './pages/view/branch-details/branch-grid/branch-grid.component';
import { BranchFormComponent } from './pages/view/branch-details/branch-form/branch-form.component';
import { ManagementComponent } from './pages/view/management-details/management/management.component';
import { OfficerComponent } from './pages/view/field-officer/officer/officer.component';
import { SupervisorGridComponent } from './pages/view/supervisor/supervisor-grid/supervisor-grid.component';
import { GuardsGridComponent } from './pages/view/guards/guards-grid/guards-grid.component';
import { EmployeesGridComponent } from './pages/view/other-employess/employees-grid/employees-grid.component';
import { ClientsGridComponent } from './pages/view/clients/clients-grid/clients-grid.component';
import { ClientsFormComponent } from './pages/view/clients/clients-form/clients-form.component';
import { ArmDetailsFormComponent } from './pages/functions/arm-details/arm-details-form/arm-details-form.component';
import { SalaryComponent } from './pages/functions/salary-slips/salary/salary.component';




import { LicenceGridComponent } from './pages/functions/licence/licence-grid/licence-grid.component';
import { LicenceFormComponent } from './pages/functions/licence/licence-form/licence-form.component';
import { ClientComponent } from './pages/home/client/client.component';
import { HomeMenuComponent } from './pages/home/home-menu/home-menu.component';
import { ManagementFormComponent } from './pages/view/management-details/management-form/management-form.component';
import { GuardsFormComponent } from './pages/view/guards/guards-form/guards-form.component';
import { ArmDetailsViewComponent } from './pages/functions/arm-details/arm-details-view/arm-details-view.component';
import { NewArmDetailsFormComponent } from './pages/functions/arm-details/new-arm-details-form/new-arm-details-form.component';
import { SupervisorFormComponent } from './pages/view/supervisor/supervisor-form/supervisor-form.component';

import { LienceReuestFormComponent } from './pages/functions/lience-reuest/lience-reuest-form/lience-reuest-form.component';
import { TrainingDetailsFormComponent } from './pages/functions/training-details/training-details-form/training-details-form.component';
import { PsaTrainingComponent } from './pages/functions/training-details/psa-training/psa-training.component';
import { TrainingCertificateComponent } from './pages/functions/training-details/training-certificate/training-certificate.component';

import { UpdatePersonnelGridComponent } from './pages/functions/personnel-details/Update-Personnel-Details/update-personnel-grid/update-personnel-grid.component';
import { PersonnelComponent } from './pages/functions/personnel-details/Personnels/personnel/personnel.component';
import { PersonnelRelievingComponent } from './pages/functions/personnel-details/Personnel-Relievings/personnel-relieving/personnel-relieving.component';
import { ExistingPersonnelComponent } from './pages/functions/personnel-details/Personnels/existing-personnel/existing-personnel.component';
import { NewPersonnelComponent } from './pages/functions/personnel-details/Personnels/new-personnel/new-personnel.component';
import { PersonnelRelievingFormComponent } from './pages/functions/personnel-details/Personnel-Relievings/personnel-relieving-form/personnel-relieving-form.component';
import { UpdatePersonnelComponent } from './pages/functions/personnel-details/Update-Personnel-Details/update-personnel/update-personnel.component';
import { PersonnelFormComponent } from './pages/functions/personnel-details/Personnels/personnel-form/personnel-form.component';
import { PersonnelHestoryComponent } from './pages/functions/personnel-details/Personnels/personnel-hestory/personnel-hestory.component';
import { HomePageComponent } from './pages/main/home-page/home-page.component';
import { AboutUsPageComponent } from './pages/Main/about-us-page/about-us-page.component';
import { VerifyPersonelPageComponent } from './pages/Main/verify-personel-page/verify-personel-page.component';
import { OtherActsPageComponent } from './pages/Main/other-acts-page/other-acts-page.component';
import { RegisterPageComponent } from './pages/Main/register-page/register-page.component';
import { ContactUsPageComponent } from './pages/Main/contact-us-page/contact-us-page.component';
import { MainPageComponent } from './pages/Main/main-page/main-page.component';
import { MainHeaderComponent } from './pages/Main/main-header/main-header.component';
import { DistrictListComponent } from './pages/Main/district-list/district-list.component';
import { FooterPageComponent } from './pages/Main/footer-page/footer-page.component';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { RouterModule, PreloadAllModules } from '@angular/router';
import { EmployeeFormComponent } from './pages/view/other-employess/employee-form/employee-form.component';
import { PsaListDetailsComponent } from './pages/main/psa-list-details/psa-list-details.component';
import { PsaNotificationsComponent } from './pages/main/psa-notifications/psa-notifications.component';
import { RelatedWebsitesComponent } from './pages/main/related-websites/related-websites.component';
import { DistrictWiseReportComponent } from './pages/view/rpt-form/report-list/district-wise-report/district-wise-report.component';
import { LicencePenddingListComponent } from './pages/view/rpt-form/report-list/licence-pendding-list/licence-pendding-list.component';
import { LicencePendingUserListComponent } from './pages/view/rpt-form/report-list/licence-pending-user-list/licence-pending-user-list.component';
import { LicenseRejectedListComponent } from './pages/view/rpt-form/report-list/license-rejected-list/license-rejected-list.component';
import { PsaBranchAddressDetailsComponent } from './pages/functions/psadetails/psa-list/psa-branch-address-details/psa-branch-address-details.component';
import { PsaManagementComponent } from './pages/functions/psadetails/psa-list/psa-management/psa-management.component';
import { PsaSupervisorsComponent } from './pages/functions/psadetails/psa-list/psa-supervisors/psa-supervisors.component';
import { PsaGuardsComponent } from './pages/functions/psadetails/psa-list/psa-guards/psa-guards.component';
import { PsaFieldOfficerComponent } from './pages/functions/psadetails/psa-list/psa-field-officer/psa-field-officer.component';
import { PsaOtherEmployeesComponent } from './pages/functions/psadetails/psa-list/psa-other-employees/psa-other-employees.component';
import { PsaSalarySlipsComponent } from './pages/functions/psadetails/psa-list/psa-salary-slips/psa-salary-slips.component';
import { PsaClientsComponent } from './pages/functions/psadetails/psa-list/psa-clients/psa-clients.component';
import { PsaLicenceComponent } from './pages/functions/psadetails/psa-list/psa-licence/psa-licence.component';
import { PsaLicenceReqFormComponent } from './pages/functions/psadetails/psa-list/psa-licence-request/psa-licence-req-form/psa-licence-req-form.component';
import { PsaLicenceReqGridComponent } from './pages/functions/psadetails/psa-list/psa-licence-request/psa-licence-req-grid/psa-licence-req-grid.component';
import { ViewPsaForm2RenewalComponent } from './pages/functions/psadetails/view-psa-form2-renewal/view-psa-form2-renewal.component';
import { ViewForm2Component } from './pages/functions/psadetails/view-form2/view-form2.component';
import { ViewForm5Component } from './pages/functions/psadetails/view-form5/view-form5.component';
import { DocInfoRequiredPsaComponent } from './pages/functions/psadetails/doc-info-required-psa/doc-info-required-psa.component';
import { Form2Component } from './pages/functions/psadetails/form2/form2.component';
import { Form5Component } from './pages/functions/psadetails/form5/form5.component';
import { DocInfoRequiredPsaAddComponent } from './pages/functions/psadetails/doc-info-required-psa-add/doc-info-required-psa-add.component';
import { Form2ViewCriminalProceedingComponent } from './pages/functions/staff-criminal-proceedings/form2-view-criminal-proceeding/form2-view-criminal-proceeding.component';
import { Form4ViewComponent } from './pages/functions/form4-view/form4-view.component';
import { PfComplianceGridComponent } from './pages/functions/pf-compliances/pf-compliance-grid/pf-compliance-grid.component';
import { PfComplianceViewComponent } from './pages/functions/pf-compliances/pf-compliance-view/pf-compliance-view.component';
import { EsiComplianceViewComponent } from './pages/functions/esi-compliances/esi-compliance-view/esi-compliance-view.component';
import { EsiComplianceGridComponent } from './pages/functions/esi-compliances/esi-compliance-grid/esi-compliance-grid.component';
import { FieldOfficerFormComponent } from './pages/view/field-officer/field-officer-form/field-officer-form.component';
import { TrainingCertificateGridComponent } from './pages/functions/training-certificate/training-certificate-grid/training-certificate-grid.component';
import { TrainingCertificateFormComponent } from './pages/functions/training-certificate/training-certificate-form/training-certificate-form.component';
import { TrainingCertificateViewComponent } from './pages/functions/training-certificate/training-certificate-view/training-certificate-view.component';
import { NewCriminalEventGridComponent } from './pages/functions/criminal-events/new-criminal-event-grid/new-criminal-event-grid.component';
import { NewCriminalEventViewComponent } from './pages/functions/criminal-events/new-criminal-event-view/new-criminal-event-view.component';
import { CriminalProceedGridComponent } from './pages/functions/criminal-proceedings/criminal-proceed-grid/criminal-proceed-grid.component';
import { CriminalProceedFormComponent } from './pages/functions/criminal-proceedings/criminal-proceed-form/criminal-proceed-form.component';
import { CriminalProceedViewComponent } from './pages/functions/criminal-proceedings/criminal-proceed-view/criminal-proceed-view.component';
import { Form4Component } from './pages/functions/form4/form4.component';
import { NewArmDetailsViewComponent } from './pages/functions/arm-details/new-arm-details-view/new-arm-details-view.component';
import { HomeTempRegistraionComponent } from './pages/home/home-temp-registraion/home-temp-registraion.component';
import { NotificationInfoComponent } from './pages/home/notification-info/notification-info.component';
import { BulkUploadComponent } from './ultilities/bulk-upload/bulk-upload.component';
// import { NgbdTooltipBasic } from './tooltip-basic';
// import { TooltipModule } from '@ngx-bootstrap/tooltip';


@NgModule({
  declarations: [
    // NgbdTooltipBasic,
    // TooltipModule,
    AppComponent,
    HeaderComponent,
    Level1menuComponent,
    LoginComponent,
    UltilitiesComponent,
    UltilitiesMenuComponent,
    UserComponent,
    SettingComponent,
    SearchbarComponent,
    RolesComponent,
    RolesGridComponent,
    RolesFormComponent,
    SignupComponent,
    UserGridComponent,
    UserFormComponent,
    ClaimGridComponent,
    ClaimFormComponent,
    ClaimsComponent,
    RegistrationComponent,
    HomepageComponent,
    ChangePasswordComponent,
    ForgotPasswordComponent,
    PetitionComponent,
    PetitionMenuComponent,
    PetitionGridComponent,
    PetitionFormComponent,
    PetitionApprovalComponent,    
    VehicleGridComponent,
    VehicleFormComponent,    
    PetitionApprovalGridComponent,
    CorrespondanceTrackingComponent,
    CtGridComponent,
    CtFormComponent,
    CtMenuComponent,    
    FooterComponent,
    HomeComponent,
    MasterComponent,
    ViewComponent,
   FunctionsComponent,
    HomeIsDepartmentComponent,
    RptFormComponent,   
    PsadetailsComponent,
    PsadetailsGridComponent,
    PsadetailsFormComponent,  
    LicenceRequestMenuComponent,
    ReportForm2Component,
    ViewCriminalEmpComponent,
    CriminalQueriesComponent,
    EmpHistoryComponent,
    NotificationFormComponent,
    NotificationGridComponent,
    PsaTrainingComponent,
    ArmDetailsComponent,
    DistictGridComponent,
    DistictFormComponent,    
    MasterDetailsComponent, 
    ViewDetailsComponent, 
    PsaCriminalProceedingsListComponent, BranchGridComponent, BranchFormComponent, 
    ManagementComponent, OfficerComponent, SupervisorGridComponent, GuardsGridComponent, 
    EmployeesGridComponent, ClientsGridComponent, ClientsFormComponent, 
    ArmDetailsFormComponent, SalaryComponent, PersonnelComponent, 
    PersonnelRelievingComponent,  
    ExistingPersonnelComponent, NewPersonnelComponent, PersonnelRelievingFormComponent, 
    UpdatePersonnelComponent, LicenceGridComponent, LicenceFormComponent, 
    ClientComponent, HomeMenuComponent, ManagementFormComponent, GuardsFormComponent,
    ArmDetailsViewComponent, 
    NewArmDetailsFormComponent, SupervisorFormComponent, 
    PersonnelFormComponent, LienceReuestFormComponent, 
    TrainingDetailsFormComponent, TrainingCertificateComponent, UpdatePersonnelGridComponent, PersonnelHestoryComponent, HomePageComponent, AboutUsPageComponent, VerifyPersonelPageComponent, OtherActsPageComponent, RegisterPageComponent, ContactUsPageComponent, MainPageComponent, MainHeaderComponent, DistrictListComponent, FooterPageComponent, EmployeeFormComponent, PsaListDetailsComponent, PsaNotificationsComponent, RelatedWebsitesComponent, DistrictWiseReportComponent, LicencePenddingListComponent, LicencePendingUserListComponent, LicenseRejectedListComponent, PsaBranchAddressDetailsComponent, PsaManagementComponent, PsaSupervisorsComponent, PsaGuardsComponent, PsaFieldOfficerComponent, PsaOtherEmployeesComponent, PsaSalarySlipsComponent, PsaClientsComponent, PsaLicenceComponent, PsaLicenceReqFormComponent, PsaLicenceReqGridComponent, ViewPsaForm2RenewalComponent, ViewForm2Component, ViewForm5Component, DocInfoRequiredPsaComponent, Form2Component, Form5Component, DocInfoRequiredPsaAddComponent, Form2ViewCriminalProceedingComponent, Form4ViewComponent, PfComplianceGridComponent, PfComplianceViewComponent, EsiComplianceViewComponent, EsiComplianceGridComponent, FieldOfficerFormComponent, TrainingCertificateGridComponent, TrainingCertificateFormComponent, TrainingCertificateViewComponent, NewCriminalEventGridComponent, NewCriminalEventViewComponent, CriminalProceedGridComponent, CriminalProceedFormComponent, CriminalProceedViewComponent, Form4Component, NewArmDetailsViewComponent, HomeTempRegistraionComponent, NotificationInfoComponent, BulkUploadComponent,

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule, MatCheckboxModule,MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule, 
    MatNativeDateModule,
    MatCheckboxModule,
    MatSelectModule,
    FormsModule,
    MatTabsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
    // NgbModule,
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: PreloadAllModules
    }),
    NgbModule,
  ],
  
  providers: [UserService, ErrorHandler,AuthGuard,{provide: LocationStrategy, useClass: HashLocationStrategy},
  // {
  //   provide: HTTP_INTERCEPTORS,
  //   useClass:AuthInterceptor,
  //   multi:true
  // }
],

  bootstrap: [AppComponent]
})
export class AppModule { } 



// WEBPACK FOOTER //
// ./src/app/khb.module.ts